<template>
 <div>
   <div v-if="reservationLoading"  class="w-100 d-flex justify-content-center align-items-center">
          <a-spin size="large" />
   </div>
   <div v-else>
     <a-modal
      title="Diensten"
      :visible="servicesPopupShow"
      @ok="handleOk"
      @cancel="handleOk"
    >
      <a-table
              :columns="servicesPopupColumns"
              :dataSource="servicesPopupServices"
              :pagination="false"
              :rowKey='(data, i)=>{return `servicespopupservice-${i}`}'
            >
              <template slot="service_name" slot-scope="service">
                <div>
                  <div>{{service.name}}</div>
                </div>
              </template>
              <template slot="prijs" slot-scope="service">
                <div>
                  <div>{{service.rate | currency}}</div>
                </div>
              </template>
              <template slot="action" slot-scope="service">
                <div>
                  <button type="button" v-if="service.selected" @click="toggleReservationService(service)" class="btn btn-danger">
                    <i class="fe fe-minus-circle" />
                  </button>
                  <button type="button" v-else @click="toggleReservationService(service)" class="btn btn-primary">
                    <i class="fe fe-plus-circle" />
                  </button>
                </div>
              </template>
            </a-table>
    </a-modal>
    <a-modal
      title="Kortingen"
      :visible="discountsPopupShow"
      @ok="handleOkDiscounts"
      @cancel="handleOkDiscounts"
    >
      <a-table
              :columns="discountsPopupColumns"
              :dataSource="discountsPopupDiscounts"
              :pagination="false"
              :rowKey='(data, i)=>{return `servicespopupservice-${i}`}'
            >
              <template slot="discount_name" slot-scope="discount">
                <div>
                  <div>{{discount.services ? discount.services.name: 'Prijskorting'}}</div>
                </div>
              </template>
              <template slot="prijs" slot-scope="discount">
                <div>
                  <div v-if="discount.discount_type === 'rate'">{{discount.discount_amount | currency}}</div>
                  <div v-else>{{discount.discount_amount}}%</div>
                </div>
              </template>
              <template slot="action" slot-scope="discount">
                <div>
                  <button type="button" v-if="discount.selected" @click="toggleReservationDiscount(discount)" class="btn btn-danger">
                    <i class="fe fe-minus-circle" />
                  </button>
                  <button type="button" v-else @click="toggleReservationDiscount(discount)" class="btn btn-primary">
                    <i class="fe fe-plus-circle" />
                  </button>
                </div>
              </template>
            </a-table>
    </a-modal>
    <a-modal
    v-if="paymentHistory.length>0"
      title="Betaalgeschiedenis"
      :visible="paymentHistoryShow"
      @ok="paymentHistoryShow = false"
      @cancel="paymentHistoryShow = undefined"
    >
    <a-table
              :columns="paymentHistoryColumns"
              :dataSource="paymentHistory"
              :pagination="false"
              :rowKey='(data, i)=>{return `paymenthistory-${i}`}'
            >
              <template slot="nummer" slot-scope="service, record, index">
                <div>
                  <div>{{index+1}}</div>
                </div>
              </template>
              <template slot="bedrag" slot-scope="paymentHistoryItem">
                <div>
                  <div>€ {{paymentHistoryItem.rate}}</div>
                </div>
              </template>
              <template slot="datum" slot-scope="paymentHistoryItem">
                <div>
                  <div>{{formatDate(paymentHistoryItem.created_at)}}</div>
                </div>
              </template>
              <template slot="status" slot-scope="paymentHistoryItem">
                <div>
                  <div>
                    <a-tag color="green" v-if="paymentHistoryItem.paid == true">
                      <b>Betaald</b>
                    </a-tag>
                    <a-tag color="#c0392b" v-if="paymentHistoryItem.done == true && paymentHistoryItem.paid == false">
                      <b>Verlopen (niet betaald)</b>
                    </a-tag>
                    <a-tag color="#c0392b" v-if="paymentHistoryItem.done == false && paymentHistoryItem.paid == false">
                      <b>Pending (niet betaald)</b>
                    </a-tag>
                  </div>
                </div>
              </template>

            </a-table>
    </a-modal>
     <change-organization-and-department-reservation ref="moveOrganizationAndDepartments" :reloadReservation="()=>{this.fetchReservation()}" :reservation_id="reservation.id" :organization_id="reservation.organization_id" :department_id="reservation.department_id" />
     <div class="row mb-3 ml-3 w-100 d-flex justify-content-between" v-if="!editMode">
      <div>
        <a-tag color="#c0392b" v-if="reservation.cancelled">
          <b>Deze reservering is geannuleerd</b>
        </a-tag>
      </div>
      <div class="d-flex">
        <div>
          <a-button type="primary" v-if="$auth.check('admin')" class="mr-2" @click="openOverview(reservation.token)">
          Overzicht
          </a-button>
          <a-button type="primary" class="mr-2" @click="openContract(reservation.token)">
          Contract
          </a-button>
        </div>
        <a-dropdown  v-if="$auth.check('admin')">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="turnOnEditMode()"> <a-icon type="edit" />Reservering wijzigen</a-menu-item>
            <a-menu-item key="2" @click="moveReservationToOtherOrgOrDep()"> <a-icon type="home" />Reservering verhuizen</a-menu-item>
            <a-menu-item key="5" @click="createPaymentRequestPopup()"> <a-icon type="euro" />Betaalverzoek</a-menu-item>
            <a-menu-item @click="cancelReservation(reservation.id)" v-if="reservation.cancelled == false" key="3" style="background-color: #eb4d4b; color: white;"> <a-icon type="close-square" />Reservering annuleren</a-menu-item>
            <a-menu-item @click="unCancelReservation(reservation.id)" v-if="reservation.cancelled == true" key="4" style="background-color: #eb4d4b; color: white;"> <a-icon type="check-square" />Reservering hervatten</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">  <a-icon type="more" /> </a-button>
        </a-dropdown>
      </div>
    <a-modal
      title="Betaalverzoek aanmaken"
      :visible="createPaymentRequestVisible"
      @ok="createPaymentRequest"
      @cancel="closePaymentRequestPopup"
    >

    <label class="typo__label font-weight-bold" v-if="false">Omschrijving</label>
    <a-input placeholder="Omschrijving" v-if="false"
      v-model="paymentRequestDescription"
      />
    <label class="typo__label font-weight-bold">Bedrag</label><br/>
      <a-input-number
      :default-value="0"
      v-model="paymentRequestAmount"
    />
    </a-modal>
     </div>
     <div class="row mb-3 ml-3 w-100 d-flex justify-content-between" v-if="editMode">
      <div>
        <a-tag color="#c0392b"  v-if="reservation.cancelled">
          <b>Deze reservering is geannuleerd</b>
        </a-tag>
      </div>
     </div>
     <div class="row">
      <div class="col-xl-6 col-lg-12">
        <div class="card">
          <div class="card-body text-dark">
            <h5 class="font-weight-bold">Persoonlijke gegevens</h5>
            <div>
              <p class="mb-1 font-weight-bold">Naam :</p>
              <p class="ml-2" v-if="!editMode"> {{`${reservation.first_name} ${reservation.last_name}`}}</p>
              <div v-else class="mb-3">
                <h5 class="input-label">Voornaam</h5>
                <a-input placeholder="Voornaam"  class="mb-2" v-model="reservation.first_name" />
                <h5 class="input-label">Achternaam</h5>
                <a-input placeholder="Achternaam" v-model="reservation.last_name" />
              </div>
            </div>
            <div>
              <p class="mb-1 font-weight-bold">E-mail :</p>
              <p class="ml-2"  v-if="!editMode"> {{`${reservation.email}`}}</p>
              <div v-else class="mb-3">
                <h5 class="input-label">E-mail</h5>
                <a-input placeholder="E-mail"  class="mb-2" v-model="reservation.email" />
              </div>
            </div>
            <div>
              <p class="mb-1 font-weight-bold">Telefoonnummer :</p>
              <p class="ml-2"  v-if="!editMode"> {{`${reservation.phone_number}`}}</p>
              <div v-else class="mb-3">
                <h5 class="input-label">E-mail</h5>
                <a-input placeholder="E-mail"  class="mb-2" v-model="reservation.phone_number" />
              </div>
            </div>
            <div>
              <p class="mb-1 font-weight-bold">Extra e-mail :</p>
              <p class="ml-2" v-if="!editMode"> {{`${(reservation.extra_email !== null) ? reservation.extra_email: ''}`}}</p>
              <div v-else class="mb-3">
                <h5 class="input-label">Extra e-mail</h5>
                <a-input placeholder="Extra e-mail"  class="mb-2" v-model="reservation.extra_email" />
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body text-dark">
            <h5 class="font-weight-bold">Vluchtgegevens</h5>
            <div>
              <p class="mb-1 font-weight-bold">Vertrek :</p>
              <p class="ml-2 mb-0" v-if="!editMode"> {{`${reservation.departure_flightnumber}`}}</p>
              <div v-else class="mb-1">
                <h5 class="input-label mb-2">Vluchtnummer vertrek</h5>
                <a-input placeholder="Vluchtnummer vertrek"  class="mb-2" v-model="reservation.departure_flightnumber" />
              </div>
              <a-tooltip v-if="!editMode">
                <template v-if="editMode" slot="title">
                  Het wijzigen van datums heeft invloed op de prijs, hierdoor is het niet mogelijk om dit hier aan te passen.
                </template>
                <p class="ml-2">{{moment(reservation.departure_time).format('DD-MM-YYYY HH:mm')}}</p>
              </a-tooltip>
              <div v-else>
                  <p class="input-label mb-1">Vertrekdatum</p>
                  <a-date-picker :allowClear='false' class="mr-2" :default-value="moment(departure_date, 'DD-MM-YYYY')" @change="onChangeDepartureDate" format="DD-MM-YYYY" />
                  <a-time-picker :allowClear='false' :default-value="moment(departure_time, 'HH:mm')" @change="onChangeDepartureTime" :minute-step="5" format="HH:mm" />
              </div>
            </div>
            <div class="mt-2">
              <p class="mb-1 font-weight-bold">Aankomst :</p>
              <p class="ml-2 mb-0" v-if="!editMode"> {{`${reservation.arrival_flightnumber}`}}</p>
              <div v-else class="mb-1">
                <h5 class="input-label mb-2">Vluchtnummer aankomst</h5>
                <a-input placeholder="Vluchtnummer aankomst" class="mb-2" v-model="reservation.arrival_flightnumber" />
              </div>
              <a-tooltip v-if="!editMode">
                <template v-if="editMode" slot="title">
                  Het wijzigen van datums heeft invloed op de prijs, hierdoor is het niet mogelijk om dit hier aan te passen.
                </template>
                <p class="ml-2">{{moment(reservation.arrival_time).format('DD-MM-YYYY HH:mm')}}</p>
              </a-tooltip>
              <div v-else>
                <p class="input-label mb-1">Aankomstdatum</p>
                <a-date-picker :allowClear='false' class="mr-2" :default-value="moment(arrival_date, 'DD-MM-YYYY')" @change="onChangeArrivalDate" format="DD-MM-YYYY" />
                <a-time-picker :allowClear='false' :default-value="moment(arrival_time, 'HH:mm')" @change="onChangeArrivalTime" :minute-step="5" format="HH:mm" />
              </div>

            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body text-dark">
            <h5 class="font-weight-bold">Opmerkingen</h5>
            <div v-if="reservation.comment !== null">
              <p class="mb-1 font-weight-bold">Opmerking factuur :</p>
              <p class="ml-2" v-if="!editMode"> {{`${reservation.comment}`}}</p>
              <div v-else class="mb-3">
                <h5 class="input-label">Opmerking factuur</h5>
                <a-textarea :rows="4"  class="mb-2" v-model="reservation.comment" />
              </div>
            </div>
            <div v-else class="mb-3">
              <h5 class="input-label">Opmerking factuur</h5>
              <a-textarea v-if="editMode" :rows="4" class="mb-2" v-model="reservation.comment" />
              <div v-else>
                Geen opmerking
              </div>
            </div>
            <div v-if="reservation.driver_comment !== null">
              <p class="mb-1 font-weight-bold">Opmerking chauffeur :</p>
              <p class="ml-2" v-if="!editMode"> {{`${reservation.driver_comment}`}}</p>
              <div v-else class="mb-3">
                <h5 class="input-label">Opmerking chauffeur</h5>
                <a-textarea :rows="4" class="mb-2" v-model="reservation.driver_comment" />
              </div>
            </div>
            <div v-else class="mb-3">
              <h5 class="input-label">Opmerking chauffeur</h5>
              <a-textarea v-if="editMode" :rows="4" class="mb-2" v-model="reservation.driver_comment" />
              <div v-else>
                Geen opmerking
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-12">
        <div class="card">
          <div class="card-body text-dark">
            <h5 class="font-weight-bold">Voertuiggegevens</h5>
            <div>
              <p class="mb-1 font-weight-bold">Merk, model en kleur :</p>
              <p class="ml-2" v-if="!editMode"> {{`${reservation.vehicle_make_model} ${reservation.vehicle_color}`}}</p>
              <div v-else class="mb-3">
                <h5 class="input-label">Merk en model</h5>
                <a-input placeholder="Merk en model"  class="mb-2" v-model="reservation.vehicle_make_model" />
                <h5 class="input-label">Kleur</h5>
                <a-input placeholder="Kleur"  class="mb-2" v-model="reservation.vehicle_color" />
              </div>
            </div>
            <div>
              <p class="mb-1 font-weight-bold">Kenteken :</p>
              <p class="ml-2" v-if="!editMode"> {{`${reservation.license_plate}`}}</p>
              <div v-else class="mb-3">
                <h5 class="input-label">Kenteken</h5>
                <a-input placeholder="Kenteken"  class="mb-2" v-model="reservation.license_plate" />
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body text-dark">
            <div class="d-flex align-items-center justify-content-between  mb-3">
              <h5 class="font-weight-bold">Diensten</h5>
              <a-button type="primary"  v-if="$auth.check('admin')" icon="setting" @click="popupServiceList()">
              </a-button>
            </div>
            <div v-for="dienst in reservation.extra" class="card bg-light" style="border: none;">
                <div class="card-body text-dark d-flex justify-content-between">
                  <div class="font-weight-bold">
                    {{dienst.title}}
                  </div>
                  <div>
                    <div v-if="dienst.done === true">
                      Al gedaan.
                    </div>
                    <div>
                      Nog niet gedaan.
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body text-dark">
            <div class="d-flex align-items-center justify-content-between  mb-3">
              <h5 class="font-weight-bold">Kortingen</h5>
              <a-button  v-if="$auth.check('admin')" type="primary" icon="setting" @click="popupDiscountList()">
              </a-button>
            </div>
            <div v-for="discount in reservation.discounts" class="card bg-light" style="border: none;">
                <div class="card-body text-dark d-flex justify-content-between">
                  <div class="font-weight-bold d-flex">
                    <p class="mb-0" v-if="discount.discount_type !== 'percentage'">&euro;</p>{{discount.discount_amount}}<p class="mb-0" v-if="discount.discount_type === 'percentage'">%</p>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body text-dark">
            <div class="d-flex justify-content-between">
              <h5 class="font-weight-bold">Prijsopbouw</h5>
              <a-button type="link" v-if="paymentHistory.length > 0" @click="showPaymentHistory">Betalingsgeschiedenis</a-button>
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Excl.</th>
                  <th scope="col">Incl. Btw</th>
                  <th scope="col">Kortingen</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Parkeerkosten</th>
                  <td>€{{(reservation.dayrate/1.21).toFixed(2)}}</td>
                  <td>€{{reservation.dayrate}}</td>
                  <td>€{{reservation.discounted_dayrate}}</td>
                </tr>
                <tr v-for="extra in reservation.extra">
                  <th scope="row">{{extra.title}}</th>
                  <td>€{{(((extra.discounted === "1") ? extra.discounted_rate : extra.rate)/1.21).toFixed(2)}}</td>
                  <td>€{{(extra.discounted === "1") ? extra.discounted_rate : extra.rate}}</td>
                </tr>
                <tr v-for="discount in reservation.discounts">
                  <th scope="row">€{{discount.discount_amount}} {{(discount.discount_type === 'percentage') ? "Procent":"Euro"}} Korting</th>
                  <td></td>
                  <td></td>
                </tr>
                <tr v-if="(parseFloat(reservation.dayrate) - parseFloat(reservation.discounted_dayrate)) !== 0">
                  <th scope="row">Kortingen toegepast</th>
                  <td>-{{((parseFloat(reservation.dayrate) - parseFloat(reservation.discounted_dayrate))/1.21).toFixed(2)}}</td>
                  <td>-{{(parseFloat(reservation.dayrate) - parseFloat(reservation.discounted_dayrate))}}</td>
                </tr>
              </tbody>
          </table>
          <div>
            <b>Totaalprijs (excl. btw) : €{{(reservation.rate/1.21).toFixed(2)}}</b>
            <br />
            <b>Totaalprijs (incl. btw) : €{{reservation.rate}}</b>
            <br /><br />
            <b>Betaalmethode : </b>
            <div v-if="reservation.organization_id && reservation.payment_method === 'factuur'">
              <b>{{reservation.organization.name ? reservation.organization.name : "Lege bedrijfsnaam"}}</b>
            </div>
            <div :class="((reservation.payment_method === 'ideal' && reservation.payment_status !== 'paid') || (reservation.payment_method === 'creditcard' && reservation.payment_status !== 'paid')) ? 'text-danger' : ''" v-else-if="reservation.payment_method">
              <b>{{reservation.payment_method}}</b>
            </div>
          </div>
          </div>
        </div>
        <div class="card" v-if="editMode">
          <div class="card-body text-dark">
            <h5 class="font-weight-bold">Prijswijziging</h5>

<div v-if="paymentMethods !== undefined">
                <p class="input-label mb-1 mt-3">Betaalmethode</p>
                <div>
                    <div>
                        <multiselect @input="onChangePaymentMethod" v-model="selectedPaymentMethod" track-by="method" :options="availablePaymentMethods" :custom-label="customLabel" :show-labels="false">
                            <template slot="singleLabel" slot-scope="props"><div class="d-flex h-100 align-items-center">
                                <img class="h-100" :src="props.option.image"><p class="h-100 ml-2 mb-0">{{ props.option.label }}</p>
                            </div></template>
                            <template slot="option" slot-scope="props"><div class="d-flex h-100 align-items-center">
                                <img class="h-100" :src="props.option.image"><p class="h-100 ml-2 mb-0">{{ props.option.label }}</p>
                            </div>
    <!--                              <div class="option__desc"><span class="option__title"></span></div>-->
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>

            <p class="input-label mb-1 mt-3 font-weight-bold">Nieuw tarief</p>
            {{price | currency}}
            <div class="mt-3">
              <a-checkbox class="ml-2" v-model="sendMailToClient">
                  Verstuur mail naar klant
              </a-checkbox>
              <br/>
              <a-checkbox  class="ml-2 mt-2" v-if="(selectedPaymentMethod.method === 'ideal' || selectedPaymentMethod.method === 'creditcard')" v-model="sendMailPayment">
                  Verstuur betaalverzoek mail naar klant
              </a-checkbox>
            </div>
            <div class="mt-5 d-flex justify-content-end">
              <a-button type="primary" :disabled="disableSave" :loading="loadingSave" class="mr-2" @click="handleUpdateFunctions()">
                Reservering wijzigen
              </a-button>
              <a-button type="link" @click="turnOffEditMode()">
                Wijzigen annuleren
              </a-button>
            </div>
          </div>
        </div>
      </div>
      </div>
   </div>
 </div>
</template>
<script>
import ChangeOrganizationAndDepartmentReservation from './ChangeOrganizationAndDepartmentReservation.vue'
import DateChangeModal from './DateChangeModal'
const servicesPopupColumns = [
  {
    title: 'Dienst',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'service_name' },
  },
  {
    title: 'Prijs',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'prijs' },
  },
  {
    className: 'bg-transparent text-right',
    scopedSlots: { customRender: 'action' },
  },
]
const discountsPopupColumns = [
  {
    title: 'Dienst',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'discount_name' },
  },
  {
    title: 'Prijs',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'prijs' },
  },
  {
    className: 'bg-transparent text-right',
    scopedSlots: { customRender: 'action' },
  },
]
const paymentHistoryColumns = [
  {
    title: 'Nummer',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'nummer' },
  },
  {
    title: 'Bedrag',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'bedrag' },
  },
  {
    title: 'Datum',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'datum' },
  },
  {
    title: 'Status',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'status' },
  },
]
export default {
  props: ['reservationId', 'changeReservationStatusStyle', 'updateReserveringsNummer'],
  components: {
    DateChangeModal,
    ChangeOrganizationAndDepartmentReservation,
  },
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data() {
    return {
      loadingSave: false,
      disableSave: false,

      reservationLoading: true,
      reservation: undefined,
      originalReservation: undefined,
      editMode: false,
      sendMailToClient: true,

      dateChangeModalVisible: false,
      departure_date: undefined,
      departure_time: undefined,
      arrival_date: undefined,
      arrival_time: undefined,
      price: 0,
      paymentMethods: undefined,
      paymentMethod: undefined,
      selectedPaymentMethod: undefined,
      availablePaymentMethods: [],
      sendMail: false,
      sendMailPayment: false,
      servicesPopupShow: false,
      servicesPopupServices: [],
      servicesPopupColumns,
      discountsPopupShow: false,
      discountsPopupDiscounts: [],
      discountsPopupColumns,
      paymentHistoryColumns,
      createPaymentRequestVisible: false,
      paymentRequestDescription: '',
      paymentRequestAmount: 0,
      paymentHistory: [],
      paymentHistoryShow: false,

    }
  },
  mounted() {
    this.fetchReservation()
  },
  methods: {
    loadPaymentHistory() {
      this.$axios.get(`/listPaymentHistory`, {
        params: {
          reserveringsnummer: this.reservation.reserveringsnummer,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.paymentHistory = response.data
      })
    },
    showPaymentHistory() {
      this.paymentHistoryShow = true
    },
    moveReservationToOtherOrgOrDep() {
      this.$refs.moveOrganizationAndDepartments.openModal()
    },
    createPaymentRequestPopup() {
      this.createPaymentRequestVisible = true
    },
    fetchPaymentMethods() {
      this.$axios.get('payment-methods', { params: {
        organization_id: (typeof this.selectedOrganization === 'object') ? this.selectedOrganization.id : null,
      } }).then((response) => {
        this.paymentMethods = response.data
        this.availablePaymentMethods = []
        this.availablePaymentMethods.push({
          label: `Op Factuur`,
          method: 'factuur',
          image: undefined,
        })
        if (response.data.hasOwnProperty('ideal')) {
          this.idealIssuer = response.data.ideal.issuers[0]
          this.availablePaymentMethods.push({
            label: `${response.data.ideal.description}`,
            method: 'ideal',
            image: response.data.ideal.image.size1x,
          })
        }
        if (response.data.hasOwnProperty('creditcard')) {
          this.availablePaymentMethods.push({
            label: `${response.data.creditcard.description}`,
            method: 'creditcard',
            image: response.data.creditcard.image.size1x,
          })
        }
        this.availablePaymentMethods.push({
          label: `Contant betalen bij aflevering`,
          method: 'contant',
          image: undefined,
        })
        this.availablePaymentMethods.push({
          label: `Pinnen bij aflevering`,
          method: 'pin',
          image: undefined,
        })
        this.selectedPaymentMethod = this.availablePaymentMethods.find((method) => {
          return method.method === this.reservation.payment_method
        })
      })
    },
    createPaymentRequest() {
      this.$axios.post(`/reservation/createPaymentRequest`, {
        reservation_id: this.reservation.id,
        // description: this.paymentRequestDescription,
        amount: this.paymentRequestAmount,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.editMode = false

        this.fetchReservation()
        this.createPaymentRequestVisible = false
      }).catch(error => {
        console.log(error)
      })
    },
    fetchReservation() {
      this.reservationLoading = true
      this.$axios.get(`/reservationsById`, {
        params: {
          id: this.reservationId ? this.reservationId : null,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.reservationLoading = false
        this.reservation = response.data
        if (this.reservation.cancelled) {
          this.changeReservationStatusStyle(true)
        } else {
          this.changeReservationStatusStyle(false)
        }
        if (this.reservation.reserveringsnummer !== null) {
          this.updateReserveringsNummer(this.reservation.reserveringsnummer)
        }
        this.originalReservation = JSON.parse(JSON.stringify(response.data))
        this.loadingSave = false
        this.disableSave = false

        this.loadPaymentHistory()
      }).catch(error => {
        console.log(error)
        // Redirect to /system/401
        this.$router.push({ path: '/system/401' })
      })
    },
    openOverview(token) {
      window.open(`https://royalparking.nl/reservation/overview/${token}`, '_blank')
    },
    openContract(token) {
      window.open(`https://royalparking.nl/reservation/contract/${token}`, '_blank')
    },
    updateReservationDates(newReservation) {
      this.reservation = newReservation
      if (this.reservation.cancelled) {
        this.changeReservationStatusStyle(true)
      } else {
        this.changeReservationStatusStyle(false)
      }
      if (this.reservation.reserveringsnummer !== null) {
        this.updateReserveringsNummer(this.reservation.reserveringsnummer)
      }
      this.originalReservation = JSON.parse(JSON.stringify(newReservation))
    },
    turnOnEditMode() {
      this.departure_date = this.moment(this.reservation.departure_time, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')
      this.departure_time = this.moment(this.reservation.departure_time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
      this.arrival_date = this.moment(this.reservation.arrival_time, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')
      this.arrival_time = this.moment(this.reservation.arrival_time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')

      this.fetchPrice()
      this.fetchPaymentMethods()

      this.editMode = true
    },
    turnOffEditMode() {
      this.editMode = false
      this.reservation = JSON.parse(JSON.stringify(this.originalReservation))
    },
    cancelReservation(reservation_id) {
      this.$axios.post(`/reservation/cancelReservation`, {
        reservation_id,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.editMode = false
        this.originalReservation = JSON.parse(JSON.stringify(response.data))
        this.reservation = JSON.parse(JSON.stringify(response.data))
        if (response.data.cancelled) {
          this.changeReservationStatusStyle(true)
        } else {
          this.changeReservationStatusStyle(false)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    unCancelReservation(reservation_id) {
      this.$axios.post(`/reservation/unCancelReservation`, {
        reservation_id,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.editMode = false
        this.originalReservation = JSON.parse(JSON.stringify(response.data))
        this.reservation = JSON.parse(JSON.stringify(response.data))
        if (response.data.cancelled) {
          this.changeReservationStatusStyle(true)
        } else {
          this.changeReservationStatusStyle(false)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    updateBaseReservation() {
      this.$axios.post(`/reservation/editBaseReservation`, {
        sendMailToClient: !!this.sendMailToClient,
        ...this.reservation,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.editMode = false
        this.originalReservation = JSON.parse(JSON.stringify(response.data))
        this.reservation = JSON.parse(JSON.stringify(response.data))
        if (this.reservation.reserveringsnummer !== null) {
          this.updateReserveringsNummer(this.reservation.reserveringsnummer)
        }

        this.fetchReservation()
      }).catch(error => {
        console.log(error)
      })
    },

    // Price Changing methods
    updatePricing(sendmail = true, sendmailpayment = true) {
      const priceChangeObject = {
        departure_time: `${this.moment(this.departure_date, 'DD-MM-YYYY').format('YYYY-MM-DD')} ${this.departure_time}:00`,
        arrival_time: `${this.moment(this.arrival_date, 'DD-MM-YYYY').format('YYYY-MM-DD')} ${this.arrival_time}:00`,
        reservation_id: this.reservation.id,
        payment_method: this.selectedPaymentMethod ? this.selectedPaymentMethod.method : null,
        send_mail_payment: this.sendMailPayment ? sendmailpayment : false,
        send_mail: this.sendMailToClient ? sendmail : false,
      }
      if (this.reservation.organization_id) {
        priceChangeObject.organization_id = this.reservation.organization_id
      }
      if (this.reservation.department_id) {
        priceChangeObject.department_id = this.reservation.department_id
      }
      console.log(priceChangeObject)
      this.$axios.post('/reservations/updateReservationDate', {
        ...priceChangeObject,
      }, { headers: {
        'Authorization': `Bearer ${this.user.user.token}`,
      } }).then(response => {
        this.dateChangeModalVisible = false
        this.editMode = false
        this.originalReservation = JSON.parse(JSON.stringify(response.data))
        this.reservation = JSON.parse(JSON.stringify(response.data))

        this.fetchReservation()
      })
    },
    onChangePaymentMethod() {
      this.fetchPrice()
    },
    onChangeDepartureDate(date) {
      this.departure_date = date
      this.fetchPrice()
    },
    onChangeDepartureTime(time) {
      this.departure_time = this.moment(time).format('HH:mm')
      this.fetchPrice()
    },
    onChangeArrivalDate(date) {
      this.arrival_date = date
      this.fetchPrice()
    },
    onChangeArrivalTime(time) {
      this.arrival_time = this.moment(time).format('HH:mm')
      this.fetchPrice()
    },
    fetchPrice() {
      this.disableSave = true
      const priceChangeObject = {
        departure_time: `${this.moment(this.departure_date, 'DD-MM-YYYY').format('YYYY-MM-DD')} ${this.departure_time}:00`,
        arrival_time: `${this.moment(this.arrival_date, 'DD-MM-YYYY').format('YYYY-MM-DD')} ${this.arrival_time}:00`,
        reservation_id: this.reservation.id,
        payment_method: this.selectedPaymentMethod ? this.selectedPaymentMethod.method : null,
      }

      if (this.reservation.organization_id) {
        priceChangeObject.organization_id = this.reservation.organization_id
      }
      if (this.reservation.department_id) {
        priceChangeObject.department_id = this.reservation.department_id
      }
      console.log(priceChangeObject)
      this.$axios.post('/reservations/getDateChangePrice', {
        dont_calculate_last_minute: true,
        ...priceChangeObject,
      }).then(response => {
        console.log(response.data)
        this.price = response.data.price
        this.disableSave = false
      })
    },
    customLabel ({ label, image }) {
      return `${label}<img src="${image}" />`
    },
    customIssuersLabel ({ name, image }) {
      return `${name}<img src="${image.size1x}" />`
    },

    handleUpdateFunctions() {
      this.loadingSave = true
      this.updateBaseReservation()
      this.updatePricing()
      this.editMode = false
    },
    popupServiceList() {
      this.$axios.get('/serviceByReservationId', {
        params: {
          reservation_id: this.reservation.id,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.servicesPopupServices = response.data.services
        this.servicesPopupShow = true
      })
    },
    popupDiscountList() {
      this.$axios.get('/discountsByReservationId', {
        params: {
          reservation_id: this.reservation.id,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.discountsPopupDiscounts = response.data.discounts
        this.discountsPopupShow = true
      })
    },
    toggleReservationService(service) {
      this.$axios.post('toggleReservationExtras', service, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.departure_date = this.moment(this.reservation.departure_time, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')
        this.departure_time = this.moment(this.reservation.departure_time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
        this.arrival_date = this.moment(this.reservation.arrival_time, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')
        this.arrival_time = this.moment(this.reservation.arrival_time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
        this.popupServiceList()
        this.updatePricing(false, false)
        console.log(response.data)
      })
    },
    toggleReservationDiscount(discount) {
      this.$axios.post('toggleReservationDiscounts', discount, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.departure_date = this.moment(this.reservation.departure_time, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')
        this.departure_time = this.moment(this.reservation.departure_time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
        this.arrival_date = this.moment(this.reservation.arrival_time, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')
        this.arrival_time = this.moment(this.reservation.arrival_time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
        this.popupDiscountList()
        this.updatePricing(false, false)
        console.log(response.data)
      })
    },
    handleOk() {
      this.servicesPopupShow = false
    },
    handleOkDiscounts() {
      this.discountsPopupShow = false
    },
    closePaymentRequestPopup() {
      this.createPaymentRequestVisible = false
    },
    formatDate(date) {
      return this.moment(date).format('DD-MM-YYYY')
    },
  },
}
</script>
<style lang="scss">
.input-label {
  display: flex;
    color: black;
    margin-bottom: 0px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 10px;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap');

  .input-label{
    margin-bottom: 0px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 10px;
  }
</style>
